import { ListOfTeamleaderAssignmentResponse } from './Api/ListOfTeamleaderAssignmentResponse';

export class EmployeeTeamleaderAssingmentEntity extends ListOfTeamleaderAssignmentResponse {
	public static tryCast(o: any) {
		const ret = new EmployeeTeamleaderAssingmentEntity();
		return Object.assign(ret, o);
	}
}
